import { render, staticRenderFns } from "./room-menu.vue?vue&type=template&id=0873463e&scoped=true&"
import script from "./room-menu.vue?vue&type=script&lang=js&"
export * from "./room-menu.vue?vue&type=script&lang=js&"
import style0 from "./room-menu.vue?vue&type=style&index=0&id=0873463e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0873463e",
  null
  
)

export default component.exports